import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { toast } from "react-toastify";
import { MonthlyDailyReport } from "../../Services/Dashboard";
import SpinnerModal from "../../Spinner/SpinnerModal";
import { Button } from "@mui/material";
import * as XLSX from "xlsx";

const MonthlyReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [monthlyReports, setMonthlyReports] = useState([]);
  const [FilterYear,setYear] = useState();

  // Fetch Monthly Reports
  const GetMonthlyDaily = async (Year) => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem("LabID");
      const response = await MonthlyDailyReport(LabID,Year);
      setMonthlyReports(response.monthlyReports);
    } catch (error) {
      toast.error("Unable to get data", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
     const currentDate = new Date();
    const Year = currentDate.getFullYear();
    GetMonthlyDaily(Year);
  }, []);
//-------------------------------------------data table===============
//--------------FILTER
const handleChange = (e) => {
    
  const selectedYear = e.target.value;
  setYear(selectedYear);

};
const Applyfilter = () =>{
  GetMonthlyDaily(FilterYear);
}
  // Define columns for the data table
  const columns = [
    {
      name: "Month",
      selector: (row) => row.monthName,
      cellExport: (row) => row.monthName,
      sortable: true,
    },
    {
      name: "Tests",
      selector: (row) => row.totalTest,
      cellExport: (row) => row.totalTest,
      sortable: true,
    },
    {
      name: "Sell",
      selector: (row) => row.totalGrandTotal,
      cellExport: (row) => row.totalGrandTotal,
      sortable: true,
    },
    {
      name: "Discount",
      selector: (row) => row.totalDiscount,
       cellExport: (row) => row.totalDiscount,
      sortable: true,
    },
    {
      name: "Received Amount",
      selector: (row) => row.receivedAmount,
      cellExport: (row) => row.receivedAmount,
      sortable: true,
    },
    {
      name: "Due Amount",
      selector: (row) => row.dueAmount,
      cellExport: (row) => row.dueAmount,
      sortable: true,
    },
  ];

  // Table Data with Extensions
  const tableData = {
    columns,
    data: monthlyReports,
  };
  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ccc', // Row border
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ccc', // Column border
      },
    },
    headCells: {
      style: {
        borderTop:'1px solid #ccc',
        borderRight: '1px solid #ccc', // Column border in header
        backgroundColor: 'white',
      },
    },
  };
  return (
    <>
      {isLoading && <SpinnerModal isLoading={isLoading} />}
      <div className="reports-container">
         <div className='row d-flex justify-content-end'>
          <div className='col-sm-2'>
            <label className='common-Labels'>Year Filter<span className='common-Asterisk'>*</span></label>
              <select className="form-select  common-Input"
                    id='Year'
                    name='Year'
                    required
                    onChange={handleChange}
                    >
                      
                    <option value='2026'>2026</option>  
                    <option value='2025'>2025</option>  
                    <option value='2024'>2024</option>  
                    <option value='2023'>2023</option>  
                </select>
            </div>
            <div  className='col-sm-1 mt-4'>
                <Button  variant="contained" onClick={Applyfilter}  type='button' className="common-button">Apply</Button>
            </div>
        </div>
         <hr></hr>
        <DataTableExtensions {...tableData}>
          <DataTable
            pagination
            fixedHeader
            fixedHeaderScrollHeight="80vh"
            highlightOnHover
            pointerOnHover
            responsive
            striped
            customStyles={customStyles}
          />
        </DataTableExtensions>
      </div>
    </>
  );
};

export default MonthlyReports;
